import React, { useMemo, useRef} from "react";
import FullCalendar from "@fullcalendar/react";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import googleCalendarPlugin from "@fullcalendar/google-calendar";
import useSwipeWeek from "./useSwipeWeek";
import listPlugin from "@fullcalendar/list";
import formatTime from "./dateUtils";

function ListCalendar({
  selectedCalendars,
  googleCalendarApiKey,
  setSelectedEvent,
}) {
const calendarRef = useRef(null);
const swipeHandlers = useSwipeWeek(calendarRef);
const handleEventClick = (info) => {
  info.jsEvent.preventDefault();
  info.jsEvent.stopPropagation();
  const eventRect = info.el.getBoundingClientRect();
  const calendarRect = info.el.closest(".list-calendar").getBoundingClientRect();
  setSelectedEvent({
    event: info.event,
    x: eventRect.left - calendarRect.left +100,
    y: eventRect.bottom - calendarRect.top +50,
  });
};

const eventSources = useMemo(
  () =>
    selectedCalendars.map((calendarId) => ({
      googleCalendarId: calendarId,
    })),
  [selectedCalendars]
);

return (
  <div className="list-calendar-wrapper" >

<button className="arrow"
      onClick={() =>
        calendarRef.current.getApi().prev()
      }
    >
      ←
    </button>
         swipe to change weeks
            <button className = 'arrow'
      onClick={() =>
        calendarRef.current.getApi().next()
      }
    >
      →
    </button>
    <div className="list-calendar"   
        {...swipeHandlers}
    >
      <FullCalendar
        ref={calendarRef}
         plugins={[
        listPlugin,
        timeGridPlugin,
        interactionPlugin,
        googleCalendarPlugin,
        ]}
        initialView="listWeek"
        allDaySlot = {false}
        firstDay={1}
        displayEventEnd= {true}
        eventTimeFormat={{
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        }}
        nextDayThreshold="09:00:00"
        headerToolbar = {{
            left: "",
            center: "title",
            right: "",
        }}
        height="auto"
        googleCalendarApiKey={googleCalendarApiKey}

        eventSources={eventSources}
        eventClick={handleEventClick}
        datesSet={() => setSelectedEvent(null)}
      />
    </div>
  </div>
);

}

export default ListCalendar;